import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class AddLeaderDialog extends React.Component {
  state = {
    polite_form: 0,
    first_name: "",
    last_name: "",
    email: "",
    tel: "",
    department: "",
    password: "",
    loading: false,
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.addChild();
      ev.preventDefault();
    }
  }

  generatePassword = () => {
    //Passwort erzeugen
    var generator = require('generate-password-browser');
    this.setState({ password: generator.generate({ length: 10, numbers: true }) });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value, ["error_" + name]: false });
  };

  handleClickShowPassword = (event) => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  onClose = success => {
    // Reset
    this.setState({ polite_form: 0, first_name: "", last_name: "", email: "", tel: "", department: "", password: "", loading: false });
    this.props.onClose(success);
  }

  createLeader = () => {
    this.setState({ loading: true });

    if (this.state.polite_form > 0 && this.state.first_name !== "" && this.state.last_name !== "" && this.state.email !== "" && this.state.tel !== "" && this.state.department !== "" && this.state.password !== "") {
      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('accept', 'json')
        .send({ command: "newleader", polite_form: this.state.polite_form, first_name: this.state.first_name, last_name: this.state.last_name, email: this.state.email, tel: this.state.tel, department: this.state.department, password: this.state.password })
        .end((err, res) => {
          var result = res.text.trim();
          if (result === "1") {
            //erfolgreich entfernt
            currentComponent.setState({ loading: false, first_name: "", last_name: "", email: "", tel: "", department: "", error_first_name: false, error_last_name: false, error_email: false, error_tel: false, error_department: false });
            currentComponent.onClose(true);
          } else {
            currentComponent.setState({ snackbar_open: true, loading: false });
          }
        });
    } else {
      this.setState({ loading: false, error_first_name: this.state.first_name === "", error_last_name: this.state.last_name === "", error_email: this.state.email === "", error_tel: this.state.tel === "", error_department: this.state.department === "" });
    }
  }

  render() {
    const { classes, fullScreen } = this.props;

    if (this.state.password === "") this.generatePassword();

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Leiter hinzufügen"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          {/* Anrede */}
          <FormControl style={{ width: "25%", marginRight: "2%", marginTop: -10 }} error={this.state.error_polite_form}>
            <InputLabel htmlFor="pf" shrink="true" required>Anrede</InputLabel>
            <Select value={this.state.polite_form} onChange={this.handleChange('polite_form')} inputProps={{ id: 'pf' }}>
              <MenuItem value={0}><em>Auswählen</em></MenuItem>
              <MenuItem value={1}>Frau</MenuItem>
              <MenuItem value={2}>Herr</MenuItem>
            </Select>
          </FormControl>
          {/* Vorname */}
          <TextField label="Vorname" value={this.state.first_name} onChange={this.handleChange('first_name')} onKeyPress={this.onEnterPressed} style={{ width: "35.5%", marginRight: "2%", marginTop: -10 }} error={this.state.error_first_name} required />
          {/* Nachname */}
          <TextField label="Nachname" value={this.state.last_name} onChange={this.handleChange('last_name')} onKeyPress={this.onEnterPressed} style={{ width: "35.5%", marginTop: -10 }} error={this.state.error_last_name} required />
          {/* E-Mail */}
          <TextField label="E-Mail-Adresse" value={this.state.email} onKeyPress={this.onEnterPressed} onChange={this.handleChange('email')} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} type="email" error={this.state.error_email} required />
          {/* Tel */}
          <TextField label="Telefonnummer" value={this.state.tel} onKeyPress={this.onEnterPressed} onChange={this.handleChange('tel')} style={{ width: "49%", marginTop: 10 }} type="tel" error={this.state.error_tel} required />
          {/* Abteilung */}
          <TextField label="Abteilung" value={this.state.department} onKeyPress={this.onEnterPressed} onChange={this.handleChange('department')} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} error={this.state.error_department} required />
          {/* Passwort */}
          <FormControl style={{ width: "49%", marginTop: 10 }} required>
            <InputLabel htmlFor="password">Passwort</InputLabel>
            <Input
              label="Passwort"
              value={this.state.password}
              onChange={this.handleChange('pw_register')}
              type="password"
              disabled
              onKeyPress={this.onEnterPressed} />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.onClose(false)} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.createLeader} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            Leiter erstellen
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Entfernen fehlgeschlagen. Versuchen Sie es später erneut.
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

AddLeaderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  programID: PropTypes.string.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(AddLeaderDialog));
